module.exports = __webpack_public_path__ + "static/media/profile.e6ad19b9.png";